/**
 * "Hangi statude ne duzenlenebilir" kurali - ekranlarin tek tek statu id'si karsilastirmasi
 * yerine buraya sorulur.
 *
 * Kurallarin sahibi sunucu; buradakiler onun aynasi:
 *  - canEditAssignedUsers  -> WorkOrderBusiness.CheckOrderStatusForUpdate
 *  - canEditPlanFields     -> MaintenancePlanBusiness.CanUpdatePlanFields
 *  - canRemoveAssignedUser -> WorkOrderUserBusiness.EnsureUsersRemovable
 * Ayrisirlarsa ekranda dugme gorunur ama sunucu istegi reddeder; degisiklik gerekirse iki
 * tarafi birlikte guncelle.
 */
import store from '../../store/index';

const statusEnums = () => store.state.enums.workOrderStatus;
const sourceEnums = () => store.state.enums.workOrderSource;

const isIncident = (orderSourceId) => Number(orderSourceId) === sourceEnums().incident;

/** Atanan personel degistirilebilir mi? Beklemede dahil. */
export function canEditAssignedUsers(orderSourceId, orderStatusId) {
  const status = statusEnums();
  const allowedStatuses = isIncident(orderSourceId)
    ? [status.new, status.onHold]
    : [status.planned, status.assigned, status.onHold];

  return allowedStatuses.includes(Number(orderStatusId));
}

/** Kaydin kendi alanlari (tarih, sure, tip, not...) degistirilebilir mi? Beklemede'de HAYIR. */
export function canEditPlanFields(orderStatusId) {
  const status = statusEnums();

  return [status.planned, status.assigned].includes(Number(orderStatusId));
}

/**
 * Atanmis bir personel kayittan cikarilabilir mi?
 *
 * Kayitta fiilen calismis personel cikarilamaz - yalnizca yeni personel eklenebilir. "Calisti"
 * olcutu sunucudan geliyor (IsWorked): kaydi Islemde'ye alan kisi. Sure kisi bazinda tutulmadigi
 * icin (Order.SpentMinutes is emrinin tamamina ait) elimizdeki tek kisi-is baglantisi budur;
 * personel performans raporu da ayni olcutu kullaniyor.
 *
 * Statu kapisi ayri bir soru: bu fonksiyon yalnizca "calisti mi"ya bakar, cagiran taraf
 * canEditAssignedUsers ile birlikte kullanir.
 */
export function canRemoveAssignedUser(user) {
  return !user.IsWorked;
}

/**
 * Multiselect'in secimden dusurdugu ama cikarilamayan (calismis) kullanicilari geri koyar.
 *
 * Multiselect tek bir secimi kilitlemeye izin vermiyor; etiket caprazi, grup secimi ve
 * "tumunu temizle" ayri ayri dusurebiliyor. Secim izlenip dusen calismis kullanici geri
 * konularak hepsi tek yerden kapatilir. Mesaji cagiran taraf basar (translate bilesene bagli).
 *
 * @returns Geri konacak bir sey yoksa null, varsa yeni secim dizisi.
 */
export function restoreWorkedUsers(selected, previous) {
  const removedWorkedUsers = previous
    .filter((user) => !canRemoveAssignedUser(user))
    .filter((user) => !selected.some((selectedUser) => selectedUser.Id === user.Id));

  return removedWorkedUsers.length === 0 ? null : [...selected, ...removedWorkedUsers];
}

/** Beklemede: kayit kilitli ama personeli degistirilebilir. */
export function isOnHold(orderStatusId) {
  return Number(orderStatusId) === statusEnums().onHold;
}
